<template>
  <div>
    <!--Dev:: data-sort 升序为asc,降序为desc,默认为升序-->
    <!-- <div class="filter">
   
        <div class="filter-item active" :data-sort="tjOrder" >
          <span class="navigation"
            >团队排序<i class="filter-item-price"></i
          ></span>
        </div>
        <div class="filter-item " :data-sort="priceOrder">
          <div class="navigation">金额排序<i class="filter-item-price"></i></div>
        </div>
        <div class="filter-item" :data-sort="ddOrder">
          <div class="navigation">订单排序<i class="filter-item-price"></i></div>
        </div>
      </div> -->

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        :offset="offset"
        finished-text="没有更多了"
        @load="loadMore"
      >
        <div
          class="member-item"
          v-for="(item, i) in dataList"
          :key="i"
        >
          <div class="th">
            <img :src="item.HeadPic" alt="" class="avatar" />
          </div>
          <div class="bd">
            <div class="name">
              {{ item.NickName
              }}{{ level == -1 ? "(" + item.DistributionLevelName + ")" : "" }}
            </div>
            <div>推广ID：{{ item.SerialNumber }}</div>
            <div class="date">加入时间:{{ item.AddDateTime }}</div>
          </div>
          <div class="ft">
            <div class="tag-box">
              <div class="tag-item">{{ item.TransactionCount }}单</div>
              <div class="tag-item">{{ item.MemberCount }}人</div>
            </div>
            <div class="price">{{ item.TotalPrice }}元</div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import common from "../tools/common";
export default {
  data() {
    return {
      options: {
        type: "GetMemberRelationSearch",
        PageIndex: 1,
        level: this.level,
      },
      option2s: {
        type: "GetMemberLevelRelationSearch",
        PageIndex: 1,
      },
      offset: 100,
      refreshing: false,
      loading: true,
      finished: false,
      dataList: [],
      tjOrder: "",
      priceOrder: "",
      ddOrder: "",
    };
  },
  components: {},
  props: {
    level: Number,
    keyWord: String,
  },
  methods: {
    init() {
      this.getList();
    },
    onRefresh() {
      this.finished = false;
      this.loading = true;
      if (this.level == -1) {
        Object.assign(this.option2s, {
          PageIndex: 1,
        });
      } else {
        Object.assign(this.options, {
          PageIndex: 1,
        });
      }
      this.getList();
    },
    loadMore() {
      if (this.level == -1) {
        Object.assign(this.option2s, {
          PageIndex: this.option2s.PageIndex + 1,
        });
      } else {
        Object.assign(this.options, {
          PageIndex: this.options.PageIndex + 1,
        });
      }
      this.loading = true;
      this.getList();
    },
    getList() {
      var that = this;
      var _options = that.level == -1 ? that.option2s : that.options;

      this.$store.dispatch(_options).then(
        (res) => {
          that.loading = false;
          if (that.refreshing) {
            that.refreshing = false;
          }
          common.Response.callNotMsgResponse(res, function(result) {
            console.log(result);
            if (result.data.length <= 0) {
              that.finished = true;
            }
            if (_options.PageIndex > 1) {
              if (result.data.length > 0) {
                result.data.forEach((element) => {
                  that.dataList.push(element);
                });
              }
            } else {
              that.dataList = result.data;
            }
          });
        },
        (error) => {
          console.log(error);
        }
      );
    },
    gomemberPage(id) {
      this.$router.push("/memberDetails?MemberId=" + id);
    },
  },
  watch: {
    keyWord: function(curVal, oldval) {
      if (curVal != oldval) {
        var _options = this.level == -1 ? this.option2s : this.options;
        Object.assign(_options, {
          Keyword: curVal,
          PageIndex: 1,
        });
        this.getList();
      }
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="less" scoped>
#member-page {
  padding-bottom: 15px;
}
.member-area-box {
  width: 100%;
  height: auto;
  padding-bottom: 10.5px;
  position: relative;
}

.member-area-box > .bg {
  width: 100%;
  display: block;
  position: absolute;
  top: 0;
  background-size: 100% 100%;
  height: 115px;
}
.profit-box {
  background: url("~@/assets/images/cash-bag.png") #fff right 25px center
    no-repeat;
  background-size: 42px 48px;
  padding: 18px 24px;
  margin: 0 10px;
  border-radius: 6px;
  z-index: 1;
  position: relative;
  margin-bottom: 15px;
  .bd {
    .profit-total {
      .profit-total-tit {
        font-size: 12px;
        color: #737373;
      }
      .profit-total-price {
        font-size: 21px;
        color: #1d1d1d;
        margin-top: 10px;
      }
    }
  }
}
//用户列表
.member-item {
  display: flex;
  align-items: center;
  margin: 20px 10px;
  .th {
    margin-right: 12px;
    .avatar {
      height: 52px;
      width: 52px;
      object-fit: cover;
      border-radius: 50%;
    }
  }
  .bd {
    flex: 1;
    overflow: hidden;
    .name {
      font-size: 14px;
      color: #000;
    }
    .date {
      font-size: 12px;
      color: #ababab;
      margin-top: 6px;
    }
  }
  .ft {
    margin-left: 5px;
    text-align: right;
    .tag-box {
      text-align: right;
      font-size: 0;
      .tag-item {
        display: inline-block;
        font-size: 10px;
        color: #fff;
        height: 18px;
        line-height: 18px;
        padding: 0 6px;
        border-radius: 3px;
        background: #ff2e56;
        margin-left: 4px;
      }
    }
    .price {
      font-size: 12px;
      color: #0a0a0a;
      margin-top: 4px;
    }
  }
}
.member-body {
  margin: 10px;
  padding: 15px;
  background: #fff;
  border-radius: 6px;
}

.search-box {
  width: 100%;
  height: auto;
  padding: 0 10px;
}

.search-box-in {
  width: 100%;
  height: 32px;
  background: #fff;
  border-radius: 6px;
  display: flex;
  align-items: center;
  padding-left: 14px;
}

.search-box-in img {
  width: 12px;
  height: 12px;
  display: block;
  margin-right: 8px;
}

.search-box-in input {
  width: 100%;
  height: 100%;
  font-size: 14px;
  color: #000;
  padding-right: 15px;
}
</style>
